import React from 'react';
import { Link } from 'react-router-dom';

export default function ScientificAdvisoryBoard() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 font-sans">
      <div className="mb-12">
        <Link to="/" className="text-indigo-600 hover:text-indigo-800 flex items-center gap-2">
          ← Back to Home
        </Link>
      </div>
      <div className="text-center">
        <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight mb-4">
          Scientific <span className="text-indigo-600">Advisory Board</span>
        </h1>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          Meet our world-class scientific advisors.
        </p>
      </div>
    </div>
  );
}
